import React, {useContext, useEffect} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import {useIntl} from 'react-intl';
import {useNavigate, useParams} from 'react-router-dom';

import {Button, message} from 'antd';
import {IoArrowBackOutline} from 'react-icons/all';
import AppPageMetadata from '@crema/core/AppPageMetadata';
import AppsContainer from '@crema/core/AppsContainer';
import AppsHeader from '@crema/core/AppsContainer/AppsHeader';
import AppsContent from '@crema/core/AppsContainer/AppsContent';
import {LocationContext, Provider} from '../LocationContext';
import LocationInfo from './LocationInfo';
import {findLocationById} from 'services/LocationService';
import {handleError} from 'utils/MessageUtils';

const DetailInfo = () => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();
  const {id} = useParams();
  const navigate = useNavigate();

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const locationContext = useContext(LocationContext);
  const {setSelectedLocation} = locationContext;

  useEffect(() => {
    if (id) {
      findLocationById(headers, id)
        .then((res) => {
          setSelectedLocation(res.data);
        })
        .catch((error) => handleError(message, error));
    }
  }, [id]);

  return (
    <>
      <AppPageMetadata title={intl.messages['common.detail']} />
      <AppsContainer
        title={intl.messages['location.info']}
        fullView
        type='bottom'>
        <AppsHeader key={'header'}>
          <div className='customer-header'>
            <div className='customer-header-input-view'>
              <Button
                type='primary'
                shape='circle'
                ghost
                icon={<IoArrowBackOutline />}
                onClick={() => navigate('/health/locations')}
              />
            </div>
          </div>
        </AppsHeader>

        <AppsContent
          key={'content'}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
          }}>
          <LocationInfo />
        </AppsContent>
      </AppsContainer>
    </>
  );
};

export default function LocationDetail() {
  return (
    <Provider>
      <DetailInfo />
    </Provider>
  );
}
